import React from 'react';
import m from 'moment';
import {observer} from 'mobx-react';
import styles from './DayView.css';

import EventView from './EventView';
import ExpandableListItem from 'components/ExpandableListItem/ExpandableListItem';

function DayView({store, day, person}) {
  let title = `${m(day.time).format('LL')}
    - ${store.convertToHours(day.totalWorkTime)}
    (${m(day.events[0].time).format('HH:mm')}
    - ${m(day.events[day.events.length - 1].time).format('HH:mm')})${day.autoLunch ? '*' : ''}`;
  return (
    <div className={styles.test}>
    <ExpandableListItem
      faulty={day.faulty}
      title={title}
    >
      {person.eventsByStint(day.events).map(stint => {
        return (
          <div className={styles.stint} key={stint.in.id || stint.out.id}>
            <EventView event={stint.in} store={store} />
            <EventView event={stint.out} store={store} />
            <div>{store.convertToHours(stint.length)}</div>
          </div>
        )
      })}
    </ExpandableListItem>
    </div>
  )
}

export default observer(DayView);

// {day.events.map(event => (
//   <EventView
//     key={event.id}
//     event={event}
//     store={store}
//   />
// ))}


// WEBPACK FOOTER //
// ./src/views/Beeper/Components/DayView.js